<div class="btn-container">
  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="viewAction()"
            [disabled]="!isViewEnabled"
    >
      <p class="btn-txt">Vizualizeaza informatii</p>
    </button>
  </div>

  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            [disabled]="!isEditEnabled"
            (click)="editAction()"
    >
      <p class="btn-txt">Editeaza informatii</p>
    </button>
  </div>

  <div class="btn-wrapper">
    <button type="button"
            style="width: 250px; margin: 5px"
            class="btn btn-primary"
            (click)="inviteAction()"
    >
      <p class="btn-txt">Trimite invitatie</p>
    </button>
  </div>
</div>
